// extracted by mini-css-extract-plugin
export default {"default":"button_default__O7cIG","outlined":"button_outlined__PbN2I","icon":"button_icon__9wmNa"};